export default __webpack_public_path__ + "static/media/inside-injuries-final-white-paper-nfl-2022-23.36b703d2.pdf";